import { render, staticRenderFns } from "./ShopManagePaymentsView.vue?vue&type=template&id=631ea883&"
import script from "./ShopManagePaymentsView.vue?vue&type=script&lang=js&"
export * from "./ShopManagePaymentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports